import type { IdeaEvent } from '@shared/types';
import { relativeTime } from '@shared/format';
import { EmptyState } from '../../../components/Card';

const EVENT_TONES: Record<IdeaEvent['type'], string> = {
  created: 'bg-accent',
  status: 'bg-info',
  assignee: 'bg-caution',
  comment: 'bg-fg-subtle',
  ai_run: 'bg-ok',
  edit: 'bg-fg-subtle',
};

/**
 * 创意动态。
 *
 * 这是本平台唯一的「历史记录」：谁在什么时候把创意推进到哪一步。
 * 它读起来像协作记录，而不是工单流转台账 —— 这是刻意的。
 */
export function EventFeed({ events }: { events: readonly IdeaEvent[] }) {
  if (events.length === 0) {
    return <EmptyState title="还没有动态" description="创意提交、认领与研判都会记录在这里。" />;
  }

  return (
    <ol className="flex flex-col">
      {events.map((event, index) => (
        <li key={event.id} className="relative flex gap-3 pb-3 last:pb-0">
          <div className="flex flex-col items-center">
            <span aria-hidden className={['mt-1.5 size-1.5 shrink-0 rounded-full', EVENT_TONES[event.type]].join(' ')} />
            {index < events.length - 1 ? <span aria-hidden className="mt-1 w-px flex-1 bg-line" /> : null}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs leading-relaxed text-fg-muted">{event.summary}</p>
            <p className="mt-0.5 text-[10px] text-fg-subtle" title={event.at}>
              {relativeTime(event.at)}
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
}
